export const classes = {
  item: 'place-start rounded-lg pl-4 pr-6 py-2 mx-2 my-1 text-grey-7 bg-white hover:bg-grey-2 cursor-pointer select-none',
};
